module.exports = __webpack_public_path__ + "static/Forte-9d63b331fe5579d649cdd61ad49698a0.svg";